import { Typography } from '@destination/components';
import { useTranslation } from 'react-i18next';

export default function SelectModelVersion() {
  const { t } = useTranslation(undefined, { keyPrefix: 'browse' });

  return (
    <Typography variant="smallTitle" className="px-3 self-center">
      {t('select_version')}
    </Typography>
  );
}
